import React from "react";
import CallStatusDonutWidget, { CallStatusDonutWidgetData } from "./CallStatusDonutWidget";

interface OutboundCallStatusWidgetProps {
  data: CallStatusDonutWidgetData;
  icon?: React.ReactNode;
  loading?: boolean;
  error?: string;
  onClick?: (filters: { [key: string]: string[] }) => void;
}

const OutboundCallStatusWidget: React.FC<OutboundCallStatusWidgetProps> = (props) => (
  <CallStatusDonutWidget
    {...props}
    title="Outbound Call Status Distribution"
    tooltipDescription="The percentage of outbound calls that were successfully answered versus those that were missed within the given time."
    directionFilterLabel="Outbound"
    legendVerticalAlign="bottom"
  />
);

export default OutboundCallStatusWidget;
